var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7241",
    d: "M9.852 11.602C10.702 15.045 8.541 17 5.56 17a5.397 5.397 0 0 1-5.398-5.398C.162 8.622 3.902 1.53 5.56 0c0 5.695 3.442 8.16 4.292 11.602Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC44C",
    d: "M8.282 12.788c.57 2.307-.88 3.617-2.882 3.617a3.62 3.62 0 0 1-3.623-3.617c0-1.997 2.51-6.748 3.623-7.773 0 1.536-.485 5.947 0 6.966.308.646.97-2.557 1.3-1.998.44.748 1.387 2.017 1.582 2.805Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF67A",
    d: "M7.232 13.52c.382 1.506-.59 2.361-1.928 2.361S2.88 14.824 2.88 13.52c0-1.305.901-4.408 1.646-5.078 0 1.004.32 4.271.644 4.936.205.423 1.282-2.01 1.502-1.645.294.489.43 1.272.56 1.787Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.77427fd6a1173494b34fc406b726e976.svg";
export { ForwardRef as ReactComponent };